module.exports = __webpack_public_path__ + "img/vasyr-2013.54d1c5f6.jpg";